var validators = {
  email: function (val) {
    if (val === undefined || val === '') {
      return true
    }
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)
  },
  emailArray: function (val) {
    var array = val.split(',')
    var result = true
    for (var i = 0; i < array.length; i++) {
      if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(array[i].trim())) {
        result = false
        break
      }
    }
    return result
  },
  password: function (val) {
    /* return /(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/.test(val) */
    return val.length >= 8
  },
  phoneCode: function (val, exp) {
    var noPhone = exp()
    return !!noPhone
  },
  phoneNumber: function (val, exp) {
    var noPhone = exp()
    if (noPhone) {
      return true
    }
    return /^\d{8,10}$/.test(val)
  },

  // phoneNumber: function (val, exp) {
  //   var bundle = exp()
  //   return (bundle.phoneCode && /^\d{8,10}$/.test(bundle.phoneNumber)) || (bundle.noPhone)
  //   // return true
  // },
  firstLastOrNick: function (val, exp) {
    // var user = exp()
    // return (!isEmptyString(user.firstName) && !isEmptyString(user.lastName)) || !isEmptyString(user.nickname)
    return true
  },
  isEqual: function (val, exp) {
    var data = exp()
    return val === data.password
  },
  isEqualEmail: function (val, exp) {
    var data = exp()
    return val === data.email
  }
}
/* var isEmptyString = function (s) {
  return s == null || s.trim() === ''
} */
module.exports = function (Vue) {
  var VueValidator = require('vue-validator')
  Vue.use(VueValidator)
  Vue.validator('email', validators.email)
  Vue.validator('emailArray', validators.emailArray)
  Vue.validator('password', validators.password)
  Vue.validator('phoneCode', validators.phoneCode)
  Vue.validator('phoneNumber', validators.phoneNumber)
  Vue.validator('firstLastOrNick', validators.firstLastOrNick)
  Vue.validator('isEqual', validators.isEqual)
  Vue.validator('isEqualEmail', validators.isEqualEmail)
}



// WEBPACK FOOTER //
// ./src/common/validators.js